import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class VariablesPublicNamesService {

  private url = `${environment.apiURL}/variables-public-names`;

  constructor(
    private http: HttpClient,
  ) {
  }

  getVariablesPublicNames(): Observable<any> {
    return this.http.get(`${this.url}`);
  }

}
